import { get, post, put } from "../common/Provider";

// const studentSignupURL = 'api/v1/admission/createIdForRegistration'; //POST
// const studentLoginURL = 'api/v1/admission/registrationLogin'; //GET

// const getStudentProfileURl = "api/v1/admission/getProfileDetails"; //GET
// const paritalSaveRegFormURL = 'api/v1/admission/updateProfileDetails'; //PUT
// const stuRegistrationURL = "api/v1/admission/completeRegistration"; //PUT

// const coursesSubjectsListByTypeURL = "api/v1/class/getCoursesByType"; //GET
// const addAdmissionPageInfoURL = "api/v1/admission/addAdmissionPageInfo"; //POST : reg. year, admission type is optional, info consists subject courses, registration acceptance range
// const updateAdmissionPageInfoURL = "api/v1/admission/updateAdmissionPageInfo"; //PUT
// const getAdmissionPageInfoURL = "api/v1/admission/getAdmissionPageInfo"; //GET

const studentSignup = (payload = {}, callback = {}) => async (dispatch) => {
  const { errorCallback, successCallback } = callback;
  const url = "api/v1/admission/createIdForRegistration";
  dispatch({ type: "SIGNUP_LOADING", payload: true });
  const res = await post(url, payload);
  dispatch({ type: "SIGNUP_LOADING", payload: false });
  if (res !== undefined) {
    const { data: { message, status } = {} } = res;
    if (status === "success") {
      successCallback();
    } else {
      errorCallback(message);
    }
  } else errorCallback("Something went wrong");
};

const studentLogin = (payload = {}, navigateTo, errorCallback) => async (dispatch) => {
  dispatch({ type: "STUDENT_LOGIN", payload: true });
  const res = await post("api/v1/admission/registrationLogin", payload);
  dispatch({ type: "STUDENT_LOGIN", payload: false });
  const { data: { status = "" } = {}, data = {} } = res || {};
  if (status === "success") {
    dispatch({
      type: "SET_STUDENT_PROFILE",
      payload: {
        profile: { ...data.profile, isStudent: true, loginType: "student" },
      },
    });
    navigateTo();
  } else {
    errorCallback();
  }
};

const getCoursesByType = (payload = {}, successCallback, errorCallback) => async (dispatch) => {
  const url = "api/v1/class/getCoursesByType";
  dispatch({ type: "COURSES_LOADING", payload: true });
  const res = await post(url, payload);
  dispatch({ type: "COURSES_LOADING", payload: false });
  if (res.data.status === "success" && Object.keys(res.data.data).length > 0) {
    successCallback(res.data.data);
  } else {
    errorCallback(res.data);
  }
};

const addAdmissionPageInfo = (payload = {}, callback) => async (dispatch) => {
  const { successCallback, failureCallback } = callback;
  const url = "api/v1/admission/addAdmissionPageInfo";
  dispatch({ type: "ADMISSION_PAGE_INFO_LOADING", payload: true });
  const res = await post(url, payload);
  dispatch({ type: "ADMISSION_PAGE_INFO_LOADING", payload: false });
  if (res.data.status === "success" && res.data) successCallback(res.data);
  else failureCallback(res.data);
};

const getAdmissionPageInfo = (payload = {}, callback) => async (dispatch) => {
  const { successCallback, failureCallback, isStudent, email_id = '', studentCallbacks } = callback;
  const url = "api/v1/admission/getAdmissionPageInfo";
  dispatch({ type: "GET_ADMISSION_PAGE_INFO_LOADING", payload: true });
  const res = await post(url, payload);

  const {data = {}} = res || {};

  if (res !== undefined && data?.message === "Data fetched successfully") {
    successCallback(data);
    if (isStudent) {
      await dispatch(getStudentProfile(email_id, studentCallbacks));
    }
    
    dispatch({ type: "ADMISSION_PAGE_INFO_LOADED", payload: true });
  } else {
    dispatch({ type: "ADMISSION_PAGE_INFO_LOADED", payload: false });
    failureCallback();
  }
  dispatch({ type: "GET_ADMISSION_PAGE_INFO_LOADING", payload: false });
};

const resetRegInfo = () => dispatch => {
  dispatch({type: 'RESET_REG'});
}

const updateAdmissionPageInfo = (payload = {}, callback) => async (dispatch) => {
  const { successCallback, failureCallback } = callback;
  const url = "api/v1/admission/updateAdmissionPageInfo";
  dispatch({ type: "ADMISSION_PAGE_INFO_LOADING", payload: true });
  const res = await put(url, payload);
  dispatch({ type: "ADMISSION_PAGE_INFO_LOADING", payload: false });
  if (res.data.status) successCallback(res.data);
  else failureCallback(res.data);
};

const getStudentProfile = (email = "", callback) => async (dispatch) => {
  const { successCallback, failureCallback } = callback;
  const url = "api/v1/admission/getProfileDetails";
  dispatch({ type: "USER_PROFILE_LOADING", payload: true });
  const res = await post(url, { email_id: email });
  dispatch({ type: "USER_PROFILE_LOADING", payload: false });
  if (res !== undefined && res.data.status) {
    dispatch({ type: 'SET_STUDENT_PROFILE', payload: { profile: { ...res?.data?.profileDetails, isStudent: true, loginType: "student" } } });
    successCallback(res.data);
  } else {
    failureCallback(res);
  }
};

const getStudentProfileByFormNumber = (formNumber = "", callback) => async (dispatch) => {
  const { successCallback, failureCallback } = callback;
  dispatch({ type: "USER_PROFILE_LOADING", payload: true });
  const res = await post("api/v1/admission/filterAllRegistrations", { formNumber: formNumber });
  if (res !== undefined && res.data.status) {
    dispatch({ type: "USER_PROFILE_LOADING", payload: false });
    dispatch({ type: "SET_SERCH_STUDENT_PROFILE", payload: res.data.registrations[0]});
    successCallback({profileDetails : res.data.registrations[0], status: true});
  } else {
    dispatch({ type: "USER_PROFILE_LOADING", payload: false });
    dispatch({ type: "SET_SERCH_STUDENT_PROFILE", payload: {}});
    failureCallback(res);
  }
}

const getStudentProfileForUpdateOnly = (email = "", callback) => async (dispatch) => {
  const { successCallback, failureCallback } = callback;
  const url = "api/v1/admission/getProfileDetails";
  dispatch({ type: "USER_PROFILE_LOADING", payload: true });
  const res = await post(url, { email_id: email });
  dispatch({ type: "USER_PROFILE_LOADING", payload: false });
  if (res !== undefined && res.data.status) {
    dispatch({ type: "SET_SERCH_STUDENT_PROFILE", payload: res?.data?.profileDetails});
    successCallback(res.data);
  } else {
    dispatch({ type: "SET_SERCH_STUDENT_PROFILE", payload: {}});
    failureCallback(res);
  }
};

const saveRegistrationForm = (payload = {}, callback) => async (dispatch) => {
  const { successCallback, failureCallback } = callback;
  const url = "api/v1/admission/updateProfileDetails";
  const res = await put(url, payload);
  if (res !== undefined && res?.data?.status) successCallback(res.data);
  else failureCallback(res?.data);
};

const completeRegistration = (email = "", callback) => async (dispatch) => {
  const { successCallback, failureCallback } = callback;
  const url = "api/v1/admission/completeRegistration";
  const res = await put(url, { email_id: email });
  if (res !== undefined && res.data.status) successCallback(res.data);
  else failureCallback(res);
};

const getAllRegistrations = (errorCallback) => async (dispatch) => {
  dispatch({ type: 'SAVE_REGISTRATIONS', payload: { registrations: [] } });
  dispatch({ type: 'FETCH_REGISTRATIONS', payload: {fetchingReg: true} });
  const res = await get("api/v1/admission/allRegistrations");
  dispatch({ type: 'FETCH_REGISTRATIONS', payload: {fetchingReg: false}});
  const { data: { status, registrations = [] } } = res || {};
  if (status) {
    dispatch({ type: 'SAVE_REGISTRATIONS', payload: { registrations } });
  } else {
    errorCallback();
  }
};

const setFetchSuccess = () => dispatch => {
  dispatch({type: 'FETCH_REGISTRATIONS', payload: {isSuccess: false}});
}


const getRegistrationsByFilter = (payload = {}, errorCallback) => async (dispatch) => {
  let isSuccess = false;
  dispatch({ type: 'SAVE_REGISTRATIONS', payload: { registrations: [] } });
  dispatch({ type: 'FETCH_REGISTRATIONS', payload: {fetchingReg: true, isSuccess} });
  const res = await post("api/v1/admission/filterAllRegistrations", payload);
  const {data: {status, registrations = []} = {}} = res || {};
  if (status) {
    isSuccess = true;
    dispatch({ type: 'SAVE_REGISTRATIONS', payload: { registrations } });
  } else {
    errorCallback(res);
  }
  dispatch({ type: 'FETCH_REGISTRATIONS', payload: {fetchingReg: false, isSuccess} });
}

const clearRegistrations = () => dispatch => {
  dispatch({ type: 'SAVE_REGISTRATIONS', payload: { registrations: [] } });
};

const updateStudentPassword = (payload, callback = {}) => async (dispatch) => {
  const {updateSuccessCallback, updateFailureCallback} = callback;
  dispatch({type: 'UPDATE_STUDENT_PASSWORD', payload: true});
  const res = await put('api/v1/admission/updateStudentPassword', payload);

  const {data = {}} = res || {};
  if (data?.message) {
    updateSuccessCallback();
  } else {
    updateFailureCallback();
  }
  dispatch({type: 'UPDATE_STUDENT_PASSWORD', payload: false});
};

const getPayableFeeForStudent = (payload, callback = {}) => async (dispatch) => {
  const {successCallback, failureCallback} = callback;
  const res = await post('api/v1/admission/fetchFeeDetailsForStudent', payload);
  const {data = {}} = res || {};
  if (data?.message) {
    successCallback(data);
  }
  else {
    failureCallback(data);
  }
};

const savePaymentRecords = (payload, callback) => async (dispatch) => {
  const { successCallback, failureCallback } = callback;
  const url = "api/v1/admission/updatePaymentDetails";
  const res = await put(url, payload);
  if (res !== undefined && res.data.status) successCallback(res.data);
  else failureCallback(res);
};

const resetStudentProfile = () => dispatch => {
  dispatch({type: 'SET_SERCH_STUDENT_PROFILE', payload: {}});
};

const getCollegeFees = (callback) => async (dispatch) => {
  const {successCallback, failureCallback} = callback;
  const res = await get('api/v1/admission/getCollegeFees');
  const {data = {}} = res || {};
  if (data?.message) {
    successCallback(data);
  }
  else {
    failureCallback(data);
  }
};

const updateCollegeFeePaymentDetails = (payload, callback = {}) => async (dispatch) => {
  const {successCallback, failureCallback} = callback;
  const res = await post('api/v1/admission/updateCollegeFeePaymentDetails', payload);
  const {data = {}} = res || {};
  if (data?.message) {
    successCallback(data);
  }
  else {
    failureCallback(data);
  }
};

const updateExaminationStatus = (payload, callback = {}) => async (dispatch) => {
  const {successCallback, failureCallback} = callback;
  const res = await put('api/v1/admission/updateExaminationStatus', payload);
  const {data = {}} = res || {};
  if (data?.message) {
    successCallback(data);
  }
  else {
    failureCallback(data);
  }
};

const generateStudId = (payload, callback = {}) => async (dispatch) => {
  const {successCallback, failureCallback} = callback;
  const res = await post('api/v1/admission/generateStudentID', payload);
  const {data = {}} = res || {};
  if (data?.message) {
    successCallback(data);
  }
  else {
    failureCallback(data);
  }
};

const generateClassRollNumber = (payload, callback = {}) => async (dispatch) => {
  const {successCallback, failureCallback} = callback;
  const res = await post('api/v1/admission/generateClassRollNumber', payload);
  const {data = {}} = res || {};
  if (data?.message) {
    successCallback(data);
  }
  else {
    failureCallback(data);
  }
};
const getStudentRestriction = (payload, callback = {}) => async (dispatch) => {
  const {failureCallback, successCallback} = callback;
  dispatch({type: 'STUDENT_RESTRICTION', payload: {restrictionLoading: true, restrictionAPICalled: false}});
  const res = await post('api/v1/admission/getStudentRestriction', payload);

  const {data: {status, login_restricted = true, err} = {}} = res || {};
  if (err && !status) {
    failureCallback(err);
  }

  if (status && login_restricted) {
    successCallback();
  }
  dispatch({type: 'STUDENT_RESTRICTION', payload: {restrictionLoading: false, login_restricted, restrictionAPICalled: true}});
};

const onClickEdit = () => dispatch => {
  dispatch({type: 'STUDENT_RESTRICTION', payload: {login_restricted: true, restrictionAPICalled: false}});
};

const updateStudentRestriction = (payload, callback) => async (dispatch) => {
  const { successCallback, failureCallback } = callback;
  const url = "api/v1/admission/updateStudentRestriction";
  const res = await put(url, payload);
  if (res !== undefined && res.data.status) successCallback(res.data);
  else failureCallback(res);
};

export {
  studentSignup,
  studentLogin,
  getCoursesByType,
  addAdmissionPageInfo,
  getAdmissionPageInfo,
  updateAdmissionPageInfo,
  getStudentProfile,
  getStudentProfileForUpdateOnly,
  saveRegistrationForm,
  completeRegistration,
  getAllRegistrations,
  clearRegistrations,
  resetRegInfo,
  updateStudentPassword,
  getRegistrationsByFilter,
  getPayableFeeForStudent,
  getStudentProfileByFormNumber,
  savePaymentRecords,
  resetStudentProfile,
  getCollegeFees,
  updateCollegeFeePaymentDetails,
  updateExaminationStatus,
  generateStudId,
  generateClassRollNumber,
  getStudentRestriction,
  onClickEdit,
  updateStudentRestriction,
  setFetchSuccess
};
